import { Delivery } from '../../models/Delivery/Delivery';
import { Dispatch } from 'redux';
import { fetcher } from '../../lib/request';

export const DELIVERY_UPDATE_REQUEST = 'DELIVERY_UPDATE_REQUEST';
export const DELIVERY_UPDATE_DATETIME = 'DELIVERY_UPDATE_DATETIME';
export const DELIVERY_UPDATE_ADDRESSES_SEARCH = 'DELIVERY_UPDATE_ADDRESSES_SEARCH';
export const DELIVERY_SET_SENDER_ADDRESS = 'DELIVERY_SET_SENDER_ADDRESS';
export const DELIVERY_SET_RECIPIENT_ADDRESS = 'DELIVERY_SET_RECIPIENT_ADDRESS';

export const GET_COURIER_SCHEDULE_REQUEST = 'DELIVERY_GET_COURIER_SCHEDULE_REQUEST';
export const GET_COURIER_SCHEDULE_RESPONSE = 'DELIVERY_GET_COURIER_SCHEDULE_RESPONSE';
export const GET_COURIER_SCHEDULE_ERROR = 'DELIVERY_GET_COURIER_SCHEDULE_ERROR';

export const GET_CARGO_TYPES_REQUEST = 'GET_CARGO_TYPES_REQUEST';
export const GET_CARGO_TYPES_RESPONSE = 'GET_CARGO_TYPES_RESPONSE';
export const GET_CARGO_TYPES_ERROR = 'GET_CARGO_TYPES_ERROR';

const COURIER_HOST = process.env.REACT_APP_COURIER_SCHEDULE_HOST;
const COURIER_KEY = process.env.REACT_APP_COURIER_SCHEDULE_KEY;

export const updateDeliveryAction = (delivery: Delivery) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DELIVERY_UPDATE_REQUEST,
        delivery
    });
};

export const setDeliveryDateTimeAction = (date: string) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DELIVERY_UPDATE_DATETIME,
        pickedDate: date
    });
};

export const setSearchAddressesAction = (addresses: Location[]) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DELIVERY_UPDATE_ADDRESSES_SEARCH,
        searchResults: addresses
    });
};

export const setSenderAddressAction = (address: Location) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DELIVERY_SET_SENDER_ADDRESS,
        pickedSenderAddress: address
    });
};

export const setRecipientAddressAction = (address: Location) => (dispatch: Dispatch<any>) => {
    dispatch({
        type: DELIVERY_SET_RECIPIENT_ADDRESS,
        pickedRecipientAddress: address
    });
};

export const getCourierScheduleAction = (date: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_COURIER_SCHEDULE_REQUEST,
        date
    });

    try {
        const response = await fetcher(`${COURIER_HOST}/api/v1/courier_schedule?date=${date}`)
            .auth(`Basic ${COURIER_KEY}`)
            .json();

        dispatch({
            type: GET_COURIER_SCHEDULE_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_COURIER_SCHEDULE_ERROR,
            error
        });
    }
};

export const getCargoTypesAction = () => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: GET_CARGO_TYPES_REQUEST
    });

    try {
        const response = await fetcher(`${COURIER_HOST}/client/v1/cargo_types`)
            .auth(`Basic ${COURIER_KEY}`)
            .json();

        dispatch({
            type: GET_CARGO_TYPES_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: GET_CARGO_TYPES_ERROR,
            error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Delivery/delivery.ts